import { useState, useCallback } from "react";
import ModalPopup from "../components/ModalPopup";

export function useAlertModal() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: "",
    message: "",
    resolve: null,
  });

  const alert = useCallback((title, message) => {
    return new Promise((resolve) => {
      setModalState({
        isOpen: true,
        title,
        message,
        resolve,
      });
    });
  }, []);

  const handleClose = () => {
    modalState.resolve(false);
    setModalState({ ...modalState, isOpen: false });
  };

  const AlertModal = (
    <ModalPopup
      titleName={modalState.title}
      content={<div className="text-center">{modalState.message}</div>}
      isOpen={modalState.isOpen}
      hasButtonClose
      onClose={handleClose}
    />
  );

  return { alert, AlertModal };
}
